export function controlModal() {
  if (window.$) {
    $(`#quick_view_modal`).modal("hide");
    // $(`#add_to_cart_modal`).modal("hide");
    // $(`#liton_wishlist_modal`).modal("hide");
  }
}

export function hideDeleteModal() {
  if (window.$) {
    $(`#delete-base-modal`).modal("hide");
  }
}

function handleScroll() {
  let scroll = $(window).scrollTop();
  
  if (scroll < 445) {
    $(".mobile-header-menu-fullwidth").removeClass("sticky-active");
    $(".ltn__header-sticky").removeClass("sticky-active");
    $(".catalog-list-filter-button").removeClass("shop-top-sticky");
    $(".catalog-list-header").removeClass("shop-top-sticky sticky-header");
  } else {
    $(".mobile-header-menu-fullwidth").addClass("sticky-active");
    $(".ltn__header-sticky").addClass("sticky-active");
    $(".catalog-list-filter-button").addClass("shop-top-sticky");
    $(".catalog-list-header").addClass("shop-top-sticky sticky-header");
  }
}

export function reloadScrollTop() {
  setTimeout(() => {
    if ($.scrollUp) {
      $.scrollUp.destroy();
    }
    
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: "linear",
      scrollSpeed: 900,
      animation: "fade",
    });
    
    $(window).off("scroll", handleScroll);
    $(window).on("scroll", handleScroll);
  }, 400);
}

export function getNiceSelectValue(setSelectValue, inputClass) {
  const checkIsNiceSelect = setInterval(() => {
    const niceSelect = document.querySelector(`.${inputClass ? inputClass : "nice-select"}:nth-child(2)`);
    if (niceSelect) {
      handleClearInterval();
      const niceSelectInputs = niceSelect.querySelectorAll("ul li");
      niceSelectInputs?.forEach((input) => {
        input?.addEventListener("click", function () {
          const dataValue = this.getAttribute("data-value");
          const value = dataValue ? dataValue : this.innerText;
          setSelectValue(value);
        });
      });
    }
  }, 100);
  
  function handleClearInterval() {
    clearInterval(checkIsNiceSelect);
  }
}
